<template>
  <v-data-table
      :headers="headers"
      :items="dogs"
      :items-per-page="20"
      :search="search"
      sort-by="kNbr"
      item-key="kNbr"
      dense
      class="elevation-1"
  >

    <template v-slot:item.dogReactive="{ item }">
      <v-simple-checkbox
          v-model="item.dogReactive"
          disabled
      ></v-simple-checkbox>
    </template>
    <template v-slot:item.humanReactive="{ item }">
      <v-simple-checkbox
          v-model="item.humanReactive"
          disabled
      ></v-simple-checkbox>
    </template>
    <template v-slot:item.dob="{ item }">
      {{ $iso2AU(item.dob) }}
    </template>

    <template v-slot:item.feePaid="{ item }">
      {{ $iso2AU(item.feePaid) }}
    </template>

    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
        ></v-text-field>
<!--
        <v-dialog v-model="dialog" max-width="950px">
        <DogEdit :dog="editedItem" :mbr="editedItem.Member"></DogEdit>
        </v-dialog>
-->
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
          small
          class="mr-2"
          @click="editTitles(item)"
      >
        mdi-seal-variant
      </v-icon>
      <v-icon
          small
          class="mr-2"
          @click="fullEditItem(item)"
      >
        mdi-pencil
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</template>

<script>
//import DateField from './DateField'
//import DogEdit from './DogEdit'
export default {
  name: 'DogTbl',
  components: {
//    DateField,
//    DogEdit
  },
  props: {
    dogs: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    search: '',
    dialog: false,
    singleExpand: false,
    headers: [
      {
        text: 'Canine',
        align: 'start',
        sortable: true,
        value: 'kNbr'
      },
      {text: 'Call name', value: 'callName'},
      {text: 'Breed', value: 'breed'},
      {text: 'D O B', value: 'dob'},
      {text: 'Dog reactive', value: 'dogReactive'},
      {text: 'Fee paid', value: 'feePaid'},
      {text: 'Human reactive', value: 'humanReactive'},
      {text: 'Owner', value: 'Member.mNbr'},
      {text: 'Owner name', value: 'Member.fullName'},
//      {text: 'Actions', value: 'actions', sortable: false},
    ],
    editedIndex: -1,
    editedItem: {
      Member: {
        mNbr: ''
      },
      microchip: '',
      callName: '',
      registeredName: '',
      dob: '',
      breed: '',
      xBreeds: '',
      gender: '',
      rescue: false,
      deceased: false,
      humanReactive: false,
      dogReactive: false,
      reactiveParking: false,
      active: true,
      note: '',
      feePaid: ''
    },
    defaultItem: {
      Member: {
        mNbr: ''
      },
      microchip: '',
      callName: '',
      registeredName: '',
      dob: '',
      breed: '',
      xBreeds: '',
      gender: '',
      rescue: false,
      deceased: false,
      humanReactive: false,
      dogReactive: false,
      reactiveParking: false,
      active: true,
      note: '',
      feePaid: ''
    }
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add Canine' : 'Edit Canine'
    },

  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created() {
    this.initialize()
    if (this.$hasRole(['adm','sys'])) {
      this.headers.push({text: 'Actions', value: 'actions', sortable: false})
    }

  },
  methods: {
    dob(event) {
      this.editedItem.dob=event
    },
    initialize() {
      // console.log('initialize()')
    },
    dis() {
      return this.editedIndex >-1
//      return (this.editedItem.Member.mNbr.length>0)
    },
    fmtDate(dt) {
      if (dt) {
        let yy = dt.slice(0, 4)
        let mm = dt.slice(5, 7)
        let dd = dt.slice(8, 10)
        return dd + '.' + mm + '.' + yy
      } else {
        return null
      }
    },
    editItem(item) {
      this.editedIndex = this.dogs.indexOf(item)
      this.editedItem = Object.assign({}, item)
      console.log(this.editedItem)
      this.dialog = true
    },
    editTitles(item) {
      this.editedIndex = this.dogs.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.$emit('beginTitleEdit', item)
    },
    fullEditItem(item) {
      this.editedIndex = this.dogs.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.$emit('beginFullEdit', item)
    },
    deleteItem(item) {
      const index = this.dogs.indexOf(item)
      if(confirm(`Are you sure you want to deactivate ${item.kNbr} ${item.callName}`)){
        item.active=false
        this.$http.post(this.$remote + '/api/moddog', {dog: item, token: this.$usrStore.token})
            .then(response => {
              this.$usrStore.token = response.data.token
              console.log(response)
              alert(`${response.data.dog.kNbr} ${response.data.dog.callName} has been marked inactive`)
              this.dogs.splice(index, 1)
            })
            .catch(reason => {
          alert('Could not update the server. Try logging in again and retry. Server reported: '+reason )
        })
      }
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    isReactive() {
      return this.item.humanReactive || this.item.dogReactive
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.dogs[this.editedIndex], this.editedItem)
        this.$http.post(this.$remote + '/api/moddog', {dog: this.editedItem, token: this.$usrStore.token})
            .then(response => {
              this.$usrStore.token = response.data.token
              console.log(response)
            }).catch(reason => {
              alert('Could not save the change on the server. Please log in again and retry. Server reported: '+reason )
        })
      } else {
        this.$http.post(this.$remote + '/api/newdog', {dog: this.editedItem, token: this.$usrStore.token})
            .then(response => {
              this.$usrStore.token = response.data.token
              console.log(response)
              this.dogs.push(response.data.dog)
            }).catch(reason => {
          alert(reason.response.message )
        })
      }
      this.close()
    },
  },
}
</script>
